import { AxiosStatic, AxiosResponse } from 'axios';
import { EocEmailEvent } from './EocEmailEvent';
import VersionedResource from '../VersionedResource';

export default class EocEmailEventResource extends VersionedResource {
  public async get(fiId: string) : Promise<EocEmailEvent[]> {
    const url = `/api/rcx/config/${fiId}/eoc-email-settings/events`;

    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      const events = response.data.data;
      events.sort((event1: EocEmailEvent, event2: EocEmailEvent) => {
        if (event1.timestamp === event2.timestamp) {
          if (event1.externalProductMappingId < event2.externalProductMappingId) {
            return 1;
          }
          return -1;
        }
        if (event1.timestamp < event2.timestamp) {
          return 1;
        }
        return -1;
      });
      return events;

      // return response.data.data;
    } catch (error) {
      // Will 404 if EmptyEocEmailEvent isn't available, so return empty EmptyEocEmailEvent
      if (error.response.status !== 404) {
        throw error;
      } else {
        return EocEmailEventResource.createEmptyEocEmailEvent();
      }
    }
  }

  public static createEmptyEocEmailEvent() : EocEmailEvent[] {
    return [{
      id: null!,
      timestamp: null!,
      cycleDropDate: null!,
      externalProductMappingId: null!,
      productMappingFiProductName: null!,
    }];
  }
}
